import { render, staticRenderFns } from "./RequestThrottlingSection.vue?vue&type=template&id=51b6d497&scoped=true"
import script from "./RequestThrottlingSection.vue?vue&type=script&lang=js"
export * from "./RequestThrottlingSection.vue?vue&type=script&lang=js"
import style0 from "./RequestThrottlingSection.vue?vue&type=style&index=0&id=51b6d497&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6d497",
  null
  
)

export default component.exports